// extracted by mini-css-extract-plugin
export default {"pagesContainer":"bflLMam4jKsl97F9G0ew","addPageButton":"bGiltQiy4dIVN5d64HTT","addPageIcon":"jn64ycl2qw9rSuEOf5iO"};